import useInterval from 'hooks/use-interval';

const DEFAULT_EXPIRATION_TIME = 1000 * 60 * 5; // 5 minutes
const alreadySelectedRecommendedStore = new Map<string, string>();

/**
 * Hook to track recommended stores that users have already selected.
 *
 * Problem: When iterating through nearby stores, we cannot change the LaunchDarkly
 * context for each individual store to evaluate its availability. This means
 * LaunchDarkly flags cannot reliably determine restaurant availability during
 * the iteration process, causing the same unavailable store to be repeatedly
 * recommended.
 *
 * Solution: Cache selected stores with timestamps and expire them after 5 minutes
 * to prevent showing the same unavailable store multiple times.
 */
export const useSavedRecommendedStores = () => {
  const setAlreadySelectedRecommendedStore = (storeId: string) => {
    alreadySelectedRecommendedStore.set(storeId, new Date().toISOString());
  };

  const clearExpiredRecommendedStores = () => {
    alreadySelectedRecommendedStore.forEach((value, key) => {
      if (new Date(value).getTime() + DEFAULT_EXPIRATION_TIME < Date.now()) {
        alreadySelectedRecommendedStore.delete(key);
      }
    });
  };

  useInterval(clearExpiredRecommendedStores, DEFAULT_EXPIRATION_TIME);

  return { alreadySelectedRecommendedStore, setAlreadySelectedRecommendedStore };
};
